import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import MuiAppBar from '@mui/material/AppBar'
import Stack from '@mui/material/Stack'
import Toolbar from '@mui/material/Toolbar'
import LogoImage from 'assets/logo.svg'
import MenuIcon from '@mui/icons-material/Menu'
import { type ElementType } from 'react'
import { useNavBar } from 'components/NavigationBar/useNavBar'
import { MainContent } from './MainContent'
import { StateSelector } from './StateSelector'

export const APP_BAR_HEIGHT = 65

const resolveIconComponent = (iconSource: unknown): ElementType => {
  if (iconSource && typeof iconSource === 'object' && 'default' in iconSource) {
    return (iconSource as { default: ElementType }).default
  }

  return iconSource as ElementType
}

export const AppBar = () => {
  const toggle = useNavBar((state) => state.toggle)
  const MenuIconComponent = resolveIconComponent(MenuIcon)
  // if environment is not prod, set header color, otherwise use white
  const nonProdEnvironment =
    import.meta.env.VITE_SENTRY_ENVIRONMENT !== 'production'

  return (
    <MuiAppBar
      position="fixed"
      sx={{ bgcolor: nonProdEnvironment ? '#ff6a38' : 'white' }}
    >
      <Toolbar>
        <Box
          color="text.primary"
          display={{ xs: 'block', sm: 'block', md: 'block', lg: 'none' }}
        >
          <IconButton
            data-testid="mobile-sidebar-button"
            onClick={() => {
              toggle()
            }}
          >
            {MenuIconComponent ? <MenuIconComponent /> : null}
          </IconButton>
        </Box>
        <Box className="flex flex-row w-[80%]">
          <Box
            sx={{
              display: {
                xs: 'none',
                sm: 'none',
                md: 'none',
                lg: 'block',
              },
            }}
          >
            <img
              alt="J&J Connect"
              src={LogoImage}
              width={200}
              style={{ height: 46 }}
              className=""
            />
          </Box>
          <Box sx={{ alignItems: 'center', display: 'flex' }}>
            <StateSelector />
          </Box>
        </Box>
        <Stack
          direction="row"
          spacing={2}
          alignItems={'center'}
          justifyContent={'center'}
          justifyItems={'center'}
        >
          <MainContent />
        </Stack>
      </Toolbar>
    </MuiAppBar>
  )
}
